<template>
    <q-carousel :class="lang">
        <q-carousel-slide v-for="(chunk, i) in chunks" :key="i">
            <div class="row gutter-xs">
                <v-card v-for="(item, j) in chunk" :key="j" :layout="layout" :item="item" :is-video="isVideo"/>
            </div>
        </q-carousel-slide>
    </q-carousel>
</template>

<script>
    import {
        QCarousel,
        QCarouselSlide
    } from 'quasar-framework'
    import {mapGetters} from "vuex";

    export default {
        name: 'VCarousel',
        data: () => ({
          appName: window.config.appName,
          lang: 'lang'+window.config.locale.toUpperCase(),
        }),
        props: {
            items: {
                type: Array,
                required: true
            },
            layout: {
                type: String,
                required: true
            },
            isVideo: Boolean
        },

        components: {
            QCarousel,
            QCarouselSlide
        },

        computed: {
            ...mapGetters({
              locale: 'lang/locale',
              locales: 'lang/locales',
              user: 'auth/user',
            }),
            chunks() {
                var chunks = []
                var chunk = 1
                if (this.layout == 'big')
                    chunk = this.$breakpoints.isGreaterThan('xs') ? 2 : 1
                if (this.layout == 'small')
                    chunk = this.$breakpoints.isGreaterThan('xs') ? 4 : 6
                for (var i = 0; i < this.items.length; i += chunk)
                    chunks.push(this.items.slice(i, i + chunk))
                return chunks
            }
        },
        mounted() {
          this.lang = 'lang'+this.locale.toUpperCase()
        }
    }
</script>

<style scoped>
.langAR{
  direction: rtl;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/front/Carousel.vue